<div class="card-header mb-4">
  <div class="title-section">
    <div style="display: flex; align-items: center; gap: 1rem">
      <button mat-stroked-button class="btn-back" (click)="goBack()" appPermissionControl="P131B0001">
        <mat-icon class="m-0">arrow_back</mat-icon>
      </button>
      <h2 class="header-title">
        Promociones / Definiciones / <span class="text-muted">{{ promocion }}</span>
      </h2>
    </div>
  </div>
  <div class="search-section">
    <div class="button-section">
      <span class="p-input-icon-left search-input">
        <i class="pi pi-search"></i>
        <input pInputText type="text" (input)="dt?.filterGlobal($any($event.target).value, 'contains')" placeholder="Buscar..." class="p-inputtext-sm" appPermissionControl="P131K0001" />
      </span>
      <button mat-flat-button (click)="openCreate()" class="btn-new" appPermissionControl="P131B0002">
        <mat-icon>add</mat-icon>
        Nuevo
      </button>
      <button mat-flat-button class="btn-cancel" (click)="openDefGeneral()" appPermissionControl="P131B0003">General</button>
      <button mat-flat-button class="btn-cancel" (click)="openDefMoratorios()" appPermissionControl="P131B0004">Moratorios</button>
    </div>
  </div>
</div>
<div class="card-white">
  <p-table
    #dt
    [value]="dataSource"
    [columns]="columns"
    [paginator]="true"
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[5, 10, 15, 20]"
    [scrollable]="true"
    scrollHeight="400px"
    styleClass="p-datatable-gridlines"
    [resizableColumns]="true"
    [autoLayout]="true"
    responsiveLayout="scroll"
    [loading]="loading"
    [globalFilterFields]="['sPromocion', 'descripcion', 'sEmpresa', 'moneda', 'sCartera']"
    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
    appPermissionControl="P131T0001"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" [pSortableColumn]="col.field !== 'actions' ? col.field : null" class="th-prime" appPermissionControl="P131C0001">
          {{ col.header }}
          <p-sortIcon *ngIf="col.field !== 'actions'" [field]="col.field"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr>
        <td *ngFor="let col of columns; let i = index" class="td-prime">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchCase="'actions'">
              <div class="d-flex gap-2 justify-content-center">
                <button
                  [disabled]="rowData.numVar == 1 || rowData.numVar == 2"
                  pButton
                  icon="pi pi-list-check"
                  class="p-button-rounded p-button-info p-button-text"
                  (click)="openUpdate(rowData)"
                  pTooltip="Editar"
                  tooltipPosition="top"
                  appPermissionControl="P131B0005"
                ></button>
                <button
                  pButton
                  icon="pi pi-trash"
                  class="p-button-rounded p-button-danger p-button-text"
                  (click)="deleteM(rowData)"
                  pTooltip="Eliminar"
                  tooltipPosition="top"
                  appPermissionControl="P131B0006"
                ></button>
              </div>
            </ng-container>
            <ng-container *ngSwitchDefault>
              {{ rowData[col.field] }}
            </ng-container>
          </ng-container>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="10" class="text-center td-prime">No hay datos para mostrar</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<!-- <br />
<mat-grid-list cols="1" rowHeight="35px">
    <mat-grid-tile rowspan="1">
        <h1 class="title">Definiciones</h1>
    </mat-grid-tile>
    <mat-grid-tile rowspan="2">
        <div style="gap: 10px; display: flex">
            <button mat-raised-button color="accent" (click)="openCreate()" appPermissionControl="P131B0007"><mat-icon class="icon">add</mat-icon>Nuevo</button>
            <button mat-raised-button color="accent" (click)="openDefinicion()" appPermissionControl="P131B0008">General</button>
            <button mat-raised-button color="accent" (click)="openMoratorios()" appPermissionControl="P131B0009">Moratorios</button>
        </div>
    </mat-grid-tile>
    <mat-grid-tile rowspan="2">
        <mat-form-field color="accent" appearance="outline">
            <mat-label>Buscar</mat-label>
            <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Ej. Tipo A" #input appPermissionControl="P131K0002">
            <mat-icon matSuffix color="accent">search</mat-icon>
        </mat-form-field>
    </mat-grid-tile>
</mat-grid-list>

<div id="div" class="mat-elevation-z8 table-responsive">
    <table mat-table [dataSource]="dataSource" matSort>

        <ng-container matColumnDef="numVar">
            <th mat-header-cell *matHeaderCellDef mat-sort-header appPermissionControl="P131C0002">Variable</th>
            <td mat-cell *matCellDef="let element">
                @if(element.numVar === 1 || element.numVar === 2) {
                <p
                    class="m-auto"
                >
                    {{ element.numVar }}
                </p>

                } @else {
                <p
                    class="m-auto"
                    (click)="openDefinicion(element)"
                    style="cursor: pointer; text-decoration: underline; text-align: center; color: blue; padding: 0"
                >
                    {{ element.numVar }}
                </p>
                }
            </td>
        </ng-container>

        <ng-container matColumnDef="descripcion">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Descripción</th>
            <td mat-cell *matCellDef="let element">
                {{ element.descripcion }}
            </td>
        </ng-container>

        <ng-container matColumnDef="formula">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Fórmula</th>
            <td mat-cell *matCellDef="let element">
                {{ element.formula }}
            </td>
        </ng-container>

        <ng-container matColumnDef="ajustes">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Ajustes</th>
            <td mat-cell *matCellDef="let element">
                <button mat-icon-button (click)="openUpdate(element)" [disabled]="element.numVar === 1 || element.numVar === 2" appPermissionControl="P131B0010">
                    <mat-icon>fact_check</mat-icon>
                </button>
            </td>
        </ng-container>

        <ng-container matColumnDef="eliminar">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Eliminar</th>
            <td mat-cell *matCellDef="let element">
                <button mat-icon-button (click)="delete(element)" appPermissionControl="P131B0011">
                    <mat-icon>delete</mat-icon>
                </button>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columns"></tr>
        <tr mat-row *matRowDef="let row; columns: columns"></tr>

        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="20">
                <span *ngIf="allData > 0">No hay resultados para "{{ input.value }}"</span>
                <span *ngIf="allData == 0 && !loading">No hay datos para mostrar</span>
                <mat-spinner *ngIf="loading" class="spinner"></mat-spinner>
            </td>
        </tr>
    </table>
    <mat-paginator [pageSizeOptions]="[5, 10, 20, 40, 80, allData]" showFirstLastButtons class="paginatorTb"></mat-paginator>
</div> -->
